import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const location = useLocation();
  const navigate = useNavigate();

  const servicePaths = [
    '/artificial-intelligence',
    '/sharepoint-consulting',
    '/salesforce-consulting',
    '/azure-aws-cloud',
    '/microsoft-power-platform',
    '/mobile-solutions',
    '/custom-application-saas',
    '/content-management-systems',
    '/identity-access-management',
    '/microsoft-copilot',
    '/uiux-design',
    '/enterprise-ai-solutions',
    '/data-engineering-solutions',
    '/devops-cloud-engineering',
    '/electronic-data-interchange',
  ];

  const isServicePage = servicePaths.some((path) =>
    location.pathname.includes(path)
  );

  const isBusinessSolutionPage =
    location.pathname.includes('/business-solutions');

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    document.documentElement.style.overflow = '';
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
    document.documentElement.style.overflow = 'hidden';
  };

  const goToHashSection = (id: string) => {
    closeDrawer();
    navigate(`/#${id}`);
  };

  const goToWork = () => {
    sessionStorage.setItem('Selected-Vertical', 'All');
    sessionStorage.setItem('Selected-Technology', 'All');
    closeDrawer();
    navigate('/work');
  };

  const goHome = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  closeDrawer();

  if (window.location.pathname === '/' && !window.location.hash) {
    window.location.reload();
  } else {
    window.location.href = '/';
  }
  };

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 400);
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (location.pathname.includes('careers')) {
      localStorage.setItem('isShowWidget', 'false');
    } else {
      localStorage.setItem('isShowWidget', 'true');
    }
  }, [location.pathname]);

  const navLink = (
    label: string,
    active: boolean,
    onClick: () => void
  ) => (
    <a
      className={active ? 'active-menu' : ''}
      href="/"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      {label}
    </a>
  );

  return (
    <AppBar
      className={`headerbox ${
        isDrawerOpen ? 'scrolledSticky' : scrolled ? 'scrolled' : ''
      }`}
    >
      <Toolbar>
        {/* Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <a href="/" className="BRLogo" onClick={goHome}>
            <img
              src="/assets/Images/header/logo.png"
              alt="Binary Republik"
              width="306"
              height="107"
            />
          </a>
        </Box>

        {/* Mobile */}
        {isMobile && (
          <>
            <Box sx={{ flexGrow: 1, textAlign: 'right' }}>
              <span onClick={isDrawerOpen ? closeDrawer : openDrawer}>
                {isDrawerOpen ? (
                  <span className="cd-nav-trigger close-nav">
                    <div className="cd-icon"></div>
                  </span>
                ) : (
                  <span className="cd-nav-trigger">
                    <div className="cd-icon"></div>
                  </span>
                )}
              </span>
            </Box>

            <Drawer
              anchor="right"
              open={isDrawerOpen}
              onClose={closeDrawer}
              className="mobilemenu"
              sx={{
                '& .MuiDrawer-paper': {
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#000',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              }}
            >
             

              <List>
                <ListItem>{navLink('Work', false, goToWork)}</ListItem>
                <ListItem>
                  {navLink('Services', location.hash === '#services', () =>
                    goToHashSection('services')
                  )}
                </ListItem>
                <ListItem>
                  {navLink(
                    'Business Solutions',
                    location.hash === '#businesssolution',
                    () => goToHashSection('businesssolution')
                  )}
                </ListItem>
                <ListItem>
                  {navLink(
                    'Careers',
                    location.pathname.includes('/careers'),
                    () => {
                      closeDrawer();
                      navigate('/careers');
                    }
                  )}
                </ListItem>
                <ListItem>
                  {navLink(
                    'Contact Us',
                    location.pathname.includes('/contact'),
                    () => {
                      closeDrawer();
                      navigate('/contact');
                    }
                  )}
                </ListItem>
              </List>
            </Drawer>
          </>
        )}

        {/* Desktop */}
        {!isMobile && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'baseline',
              justifyContent: 'right',
              flexGrow: 1,
            }}
          >
            <div className="TopNavigation">
              {navLink(
                'WORK',
                location.pathname === '/work',
                goToWork
              )}

              {navLink(
                'SERVICES',
                isServicePage || location.hash === '#services',
                () => goToHashSection('services')
              )}

              {navLink(
                'BUSINESS SOLUTIONS',
                isBusinessSolutionPage ||
                  location.hash === '#businesssolution',
                () => goToHashSection('businesssolution')
              )}

              {navLink(
                'CAREERS',
                location.pathname.includes('/careers'),
                () => navigate('/careers')
              )}

              {navLink(
                'CONTACT US',
                location.pathname.includes('/contact'),
                () => navigate('/contact')
              )}
            </div>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
